import { render, staticRenderFns } from "./dataDicts.vue?vue&type=template&id=ec26b76c&scoped=true&"
import script from "./dataDicts.vue?vue&type=script&lang=js&"
export * from "./dataDicts.vue?vue&type=script&lang=js&"
import style0 from "./dataDicts.vue?vue&type=style&index=0&id=ec26b76c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec26b76c",
  null
  
)

export default component.exports